import { client } from "@/lib/prismicio/init"
import { transPopup } from "@jog/react-components"

export const fetchPopup = () => client.getSingle("popup").then((res) => transPopup(res.data))
